import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamKOKR() {
  return (
    <div className={styles["declaration"]}>
      <h1>채널 소매 시험 규정 준수 선언</h1>

      <p>
        Xiaomi 국제부 교육팀(이하 “당사” 또는 ‘본사’)은 아웃소싱 서비스 제공업체가 지정한 제3자 판촉직원(이하 “교육생”)의 서비스 품질을 지속적으로 향상시키기 위해 교육 과정 및 동반 지식 강화 시험을 제공합니다. 교육 및 시험의 목적은 교육 내용을 최적화하고 학습 성과를 공고히 하는 데 있으며, 어떠한 형태의 고용 관계나 실제적 관리 행위로 간주되지 않습니다. 다음은 교육 및 시험에 관한 선언문입니다.
      </p>

      <ol>
        <li>
          <strong>교육 및 시험의 성격</strong><br/>
          모든 교육 과정과 시험은 지식 공유를 목적으로 진행되며, 교육생들이 제품 정보 및 서비스 기준 등을 체계적으로 이해할 수 있도록 돕는 데 그 목적이 있습니다. 시험 결과는 교육 내용에 대한 교육생의 이해도를 반영할 뿐이며, 성과 평가의 기준으로 활용되지 않습니다. 당사는 외주 서비스 제공업체의 성과 평가, 급여 분배 또는 기타 고용 관련 사항에 대해 어떠한 권한도 없으며, 이에 관여하지 않습니다.
        </li>
        <li>
          <strong>법률 관계 설명</strong><br/>
          본 교육 및 시험 프로그램은 교육생과 각 외주 서비스 제공업체 간의 고용 관계에 어떠한 영향도 미치지 않습니다. 당사와 교육생 간에는 고용주-피고용인 관계가 존재하지 않으며, 본 지식 공유 교육 및 시험 프로그램 역시 교육생과의 사실상의 고용 관계를 형성하지 않습니다. 고용에 관한 모든 권리와 의무는 아웃소싱 서비스 제공자와 교육생 간에만 적용됩니다.
        </li>
        <li>
          <strong>시험 결과 활용</strong><br/>
          시험 결과는 다음과 같은 목적으로만 활용해야 합니다:
          <ol type="1">
            <li>당사 내부 과정 최적화 및 개선을 위한 참고 자료로 활용;</li>
            <li>아웃소싱 서비스 제공자에게 제공되며, 이는 교육생의 전문적 역량 증빙 자료로 활용됩니다. 다만, 아웃소싱 서비스 제공자의 독립적 판단과 의사에 따릅니다.</li>
            <li>시험 결과는 공개되지 않으며 제3자에게도 제공되지 않습니다.</li>
          </ol>
        </li>
      </ol>

      <p>
        본 선언문은 공고일로부터 효력을 발생합니다. 교육 및 시험 프로그램에 참여하는 것은 교육생이 본 선언문을 인지하고 이에 동의함을 의미합니다. 당사는 본 선언문에 대한 해석 권한을 보유하며, 합리적인 범위 내에서 이를 수시로 수정할 수 있습니다. 단, 이러한 수정은 본 교육 및 시험의 비고용적 성격을 변경하지 않습니다. 다국어 버전 간에 분쟁이나 해석상의 불일치가 발생할 경우, 영어 버전이 우선적으로 적용됩니다.
      </p>

      <div className={styles["footer"]}>
        Xiaomi 국제부 교육팀<br/>
        날짜: {getLocalizedTime('ko-KR')}
      </div>
    </div>
  );
}